import { useState, useEffect } from 'react'
import { api, setToken } from '../api'
import { Card, Form, Input, Button, Typography, Alert } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

export default function Login({ onLogin }) {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [config, setConfig] = useState({})

  useEffect(() => {
    fetch('/api/config').then(r => r.json()).then(d => setConfig(d)).catch(() => {})
  }, [])

  const handleLogin = async (values) => {
    setLoading(true)
    setError('')
    try {
      const data = await api('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email: values.email, password: values.password }),
      })
      setToken(data.token)
      onLogin(data.token, data.usuario)
    } catch (err) {
      setError(err.message || 'Email o contraseña incorrectos')
    }
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #1B3A6B 0%, #2E7D32 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          {config.logo_url ? (
            <img src={config.logo_url} alt="Logo" style={{ height: '80px', marginBottom: '12px', borderRadius: '8px' }} />
          ) : (
            <div style={{ fontSize: '56px', marginBottom: '8px' }}>🌾</div>
          )}
          <Title level={2} style={{ color: 'white', margin: 0 }}>{config.nombre_app || 'Cox Agro'}</Title>
          <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>Gestión agrícola integral</Text>
        </div>

        <Card bordered={false} style={{ borderRadius: '16px' }}>
          <Form layout="vertical" onFinish={handleLogin} size="large">
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: 'Introduce tu email' }]}
            >
              <Input
                prefix={<UserOutlined style={{ color: '#bbb' }} />}
                placeholder="tu@email.com"
                type="email"
              />
            </Form.Item>

            <Form.Item
              label="Contraseña"
              name="password"
              rules={[{ required: true, message: 'Introduce tu contraseña' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: '#bbb' }} />}
                placeholder="••••••••"
              />
            </Form.Item>

            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginBottom: '16px' }}
              />
            )}

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                style={{ height: '46px', fontWeight: '600', fontSize: '15px' }}
              >
                Entrar
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  )
}
